import airteam3DViewer from "./endpoints/airteam3DViewer";
import projects from "./endpoints/projects";
const API = {
  airteam3DViewer,
  projects,
};

export default API;
